import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Modal } from 'semantic-ui-react';
import { connect } from 'react-redux';
import history from '../../history';
import { STATUS } from '../../utils/status';
import { calculateWin } from '../CreateStake/OddsSlider';
import { updateStake } from '../../firebase';
import { updateUserBalanceAction } from '../rootReducer';

import ViewStake from './ViewStake';

class ClaimedStake extends Component {
  static propTypes = {
    stake: PropTypes.object.isRequired
  };

  state = {
    isLoading: false
  };

  cancelClaim = () => {
    this.setState({ isLoading: true });
    const stake = { ...this.props.stake };
    stake.status = STATUS.Live;
    
    delete stake.playerClaiming;

    updateStake(stake, this.props.stake.id);
    history.push('/');
  };

  concedeStake = () => {
    this.setState({ isLoading: true });
    const stake = { ...this.props.stake };
    stake.status = STATUS.Settled;

    stake.winner = stake.isMyStake ? stake.stakee : stake.stakerId;
    // Return liability as well as profit to winner
    const totalReturn = calculateWin(stake.amount, stake.odds) + stake.amount;

    updateStake(stake, this.props.stake.id)
    .then(() => {
      this.props.updateUserBalanceAction(totalReturn, stake.winner);
      history.push('/');
    });
  };

  render() {
    const { isLoading } = this.state;
    const { stake, user } = this.props;

    const isMyclaim = stake.playerClaiming === user.sub;

    return (
      <ViewStake
        stake={stake}
        actions={
          isMyclaim ? (
            <Button fluid color="grey" size="large" loading={isLoading} disabled={isLoading} onClick={this.cancelClaim}>
              Cancel
            </Button>
          ) : (
            <div className="equal-width">
              <Button
                fluid
                negative
                size="large"
                loading={isLoading}
                disabled={isLoading}
                onClick={this.declineStake}
              >
                Decline
              </Button>
              <Modal
                size="mini"
                trigger={
                  <Button fluid primary size="large" loading={isLoading} disabled={isLoading}>
                    Accept
                  </Button>
                }
                header="Concede Stake"
                content="Are you sure you want to concede the stake?"
                actions={['No', { key: 'concede', content: 'Concede', negative: true, onClick: this.concedeStake }]}
              />
          </div>
          )
        }
      />
    );
  }
}

export default connect(null, { updateUserBalanceAction })(ClaimedStake);



// WEBPACK FOOTER //
// ./src/App/ViewStake/ClaimedStake.js